/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.discovery.studio.rpc.PlacementsRpc
 */
import * as References from './PlacementsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.discovery.studio.rpc.PlacementsRpc#getPlacements
 */
export const GET_PLACEMENTS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_discovery_studio_rpc_PlacementsRpc_getPlacements';
export const GET_PLACEMENTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PLACEMENTS_QUERY_FIELD_NAME,
  args: ['page', 'published'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getPlacementsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});